import { FC, useRef, useState } from 'react'
import useOutsideAlerter from '../../hooks/useOutsideAlerter'
import { StyledPopup } from '../styled/StyledPopup'
import { generateUniqueId } from '../utils/basic'

interface Props {
    children: JSX.Element
    containerStyles?: React.CSSProperties
    popupStyles?: React.CSSProperties
    content: JSX.Element
    isNested?: boolean
    closeOnClick?: boolean
    position?: 'left' | 'right'
}

const Popup: FC<Props> = ({
    children,
    containerStyles,
    popupStyles,
    content,
    isNested = false,
    closeOnClick = true,
    position = 'right',
}) => {
    const [isPopupVisible, setIsPopupVisible] = useState(false)
    const popupContainerRef = useRef(null)

    /*need component id to make sure the styled-component is not toggling all the nested popups at the same time*/
    const componentId = useRef(generateUniqueId())

    useOutsideAlerter({ elementRef: popupContainerRef, callback: () => setIsPopupVisible(false) })

    return (
        <StyledPopup
            position={position}
            isNested={isNested}
            componentId={componentId.current}
            ref={popupContainerRef}
            isActive={isPopupVisible}
            style={containerStyles}>
            <div
                onClick={() => {
                    setIsPopupVisible(prev => {
                        if (prev && closeOnClick) return false
                        return true
                    })
                }}>
                {children}
            </div>

            {/*need component id to make sure the styled-component is not toggling all the nested popups at the same time*/}
            <div id={`StyledPopupMainPopup-${componentId.current}`} style={popupStyles}>
                {content}
            </div>
        </StyledPopup>
    )
}

export default Popup
